import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras} from '@angular/router';
import { GetRenewalDetailService } from '../../adapters/getRenewalDetail.service';
import { environment } from '../../../environments/environment';
declare var window: any;

@Component({
    selector: 'app-payment-detail',
    templateUrl: './payment-detail.component.html',
    styleUrls: ['./payment-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentDetailComponent implements OnInit {

  insuredetail_data: any;
  dataucid: any;
  letterucid: any;
  loader = signal<boolean>(false);

  mockup_data: any = [
    {amount: 2000, date: "15/7/2021"},
    {amount: 2000, date: "15/8/2021"},
    {amount: 2000, date: "15/9/2021"},
  ]

  inst: any = [];

  check: boolean = false;

  installment = signal<any>([]);

  constructor(
    private getRenewalDetailService: GetRenewalDetailService,
    private route: ActivatedRoute,
    private router: Router) { 
      this.insuredetail_data = {
        additionalProduct: [],
        address: "",
        carBrand: "",
        carNo: "",
        carProvince: null,
        carUsage: null,
        carYear: null,
        claim: [],
        decoration: [],
        installment: [],
        insuredName: "",
        lastClaimDate: "",
        name: "",
        oldExpireDate: "",
        oldInsureModel: "",
        oldInsureNo: "",
        oldInsureType: null,
        phoneNo: "",
        protection1: 0,
        protection2: 0,
        protection3: 0,
        protection4: 0,
        protection5: 0,
        protection6: 0,
        protection7: 0,
        protection8: 0,
        protection9: 0,
        protection10: 0,
        protection11: 0,
        protection12: 0,
        refNo: "",
        totalamount: 0,
        insuranceType: "",
        product_type: "",
        instTerm: 0,
        instFirstDate: "",
      }
    }

  async ngOnInit() { 
    // if (environment.log_level == 'debug') {
    //     window.vConsole = new window.VConsole();
    // }
    this.route.queryParams.subscribe(async (params) => {
      this.dataucid = params['dataucid'];
      this.letterucid = params['letterucid'];
      await this.getData(this.dataucid, this.letterucid);
    });
    
  }

  async getData(dataucid: any, letterucid: any) {
    this.getRenewalDetailService.exec({ dataucid: dataucid, letterucid: letterucid }).then(async (res: any) => {
      console.log(res);
      this.insuredetail_data = res.data.obj;
      for(let i=0;i<this.insuredetail_data.installment.length;i++) {
        if(this.insuredetail_data.installment[i].amount != 0) {
          let date = new Date(this.insuredetail_data.installment[i].date);
          let month = date.getUTCMonth() + 1;
          let day = date.getDate();
          let year = date.getUTCFullYear();
          this.installment.update(list => [...list , {amount: this.insuredetail_data.installment[i].amount, date: `${day}/${month}/${year}`}]);
          // this.installment = this.mockup_data;
          this.check = true;
        }
      }
      console.log(this.installment());
      // if (this.check) {
      //   this.inst = await this.calInstTerm();
      //   console.log(this.inst);
      // }
      this.loader.set(true);
    });
  }

  public async calInstTerm() {
    var dateObj = new Date();
    var month_current = dateObj.getUTCMonth() + 1;
    var day_current = dateObj.getDate();
    var year_current = dateObj.getUTCFullYear();

    

    // let i=this.installment.length;
    // while(i > 0) {
    //   var date_install = this.installment[i].date.split("/");
    //   if (year_current == parseInt(date_install[2])) {
    //     if (month_current == parseInt(date_install[1])) {
    //       if (day_current < parseInt(date_install[0])) {
    //         i--;
    //       }
    //       else if (day_current == parseInt(date_install[0])){ 
    //         // check time < 16.30
    //         i--;
    //       }
    //       else {
    //         console.log('1');
    //         for(let j=0;j<i;j++) {
    //           this.installment[i].amount = this.installment[i].amount + this.installment[j].amount;
    //           this.installment[i].date = this.installment[j].date;
    //           this.installment.splice(j,1);
    //         }
    //         break;
    //       }
    //     }
    //     else if (month_current < parseInt(date_install[1])) {
    //       console.log('2');
    //       for(let j=0;j<i;j++) {
    //         this.installment[i].amount = this.installment[i].amount + this.installment[j].amount;
    //         this.installment[i].date = this.installment[j].date;
    //         this.installment.splice(j,1);
    //       }
    //       break;
    //     }
    //     else { 
    //       i--;
    //     }
    //   }
    //   else if (year_current > parseInt(date_install[2])) {
    //     if ((12+month_current-parseInt(date_install[1])) < this.installment.length) {
    //       for(let j=0;j<i;j++) {
    //         this.installment[i].amount = this.installment[i].amount + this.installment[j].amount;
    //         this.installment[i].date = this.installment[j].date;
    //         this.installment.splice(j,1);
    //       }
    //       break;
    //     }
    //     else {
    //       console.log(" > term");
    //       i--;
    //     }
    //   }
    // }
    return this.installment();
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }


}
